<template>
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/home">{{lang.LBL_HOME}}</router-link></li>
        <li><router-link to="/modules/budgetheads/edit">{{lang.LBL_ADD_BUDGETHEAD}}</router-link></li>
        <li><router-link to="/modules/budgetheads">{{lang.LBL_VIEW_BUDGETHEAD}}</router-link></li>
    </ul>
</template>
<script>
import lang from "@/views/modules/BudgetHeads/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
        }
     },
     mounted() {
        this.lang = lang;
        let user = JSON.parse(localStorage.getItem('user_prefrence'));
    },
    methods:{
       
    }
}
</script>
